// extracted by mini-css-extract-plugin
module.exports = {"icon":"UserFormContent_icon__3s6BH"};